export const PredefinedStateName = {
  Offline: 'Offline',
  Available: 'Available',
  OnCall: 'On Call',
  Acw: 'ACW',
  Bcw: 'BCW',
  Training: 'Training',
  Meeting: 'Meeting',
  Break: 'Break',
  ShortBreak: 'Short Break',
  LunchBreak: 'Lunch Break',
} as const;
